import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import * as serviceWorker from './serviceWorker'
import './bulma/bulma.scss'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

serviceWorker.unregister()
